import { render, staticRenderFns } from "./TheAside.vue?vue&type=template&id=04ccdf0a&"
import script from "./TheAside.vue?vue&type=script&lang=js&"
export * from "./TheAside.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\yuichi\\git\\open_coupon\\public\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04ccdf0a')) {
      api.createRecord('04ccdf0a', component.options)
    } else {
      api.reload('04ccdf0a', component.options)
    }
    module.hot.accept("./TheAside.vue?vue&type=template&id=04ccdf0a&", function () {
      api.rerender('04ccdf0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/containers/TheAside.vue"
export default component.exports